import React from 'react'

interface CoffeeIconProps {
  className?: string;
}

const CoffeeIcon: React.FC<CoffeeIconProps> = ({ className }) => {
  return (
    <svg  width="24" height="24" className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M20 3H4V13C4 14.0609 4.42143 15.0783 5.17157 15.8284C5.92172 16.5786 6.93913 17 8 17H14C15.0609 17 16.0783 16.5786 16.8284 15.8284C17.5786 15.0783 18 14.0609 18 13V10H20C20.5304 10 21.0391 9.78929 21.4142 9.41421C21.7893 9.03914 22 8.53043 22 8V5C22 4.46957 21.7893 3.96086 21.4142 3.58579C21.0391 3.21071 20.5304 3 20 3ZM20 8H18V5H20V8ZM20 19H4V21H20V19Z" fill="#1E293B"/>
</svg>

  )
}

export default CoffeeIcon

